'use strict';

var React = require('react');

var SvgKeyboardMinor = function SvgKeyboardMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 7.55c0-.58.47-1.05 1.05-1.05h11.9c.58 0 1.05.47 1.05 1.05v4.9c0 .58-.47 1.05-1.05 1.05h-11.9c-.58 0-1.05-.47-1.05-1.05v-4.9Zm2.1.35h1.4v1.4h-1.4v-1.4Zm.7 2.8v1.4h1.4v-1.4h-1.4Zm5.6 1.4h-2.8v-1.4h2.8v1.4Zm-2.1-4.2h-1.4v1.4h1.4v-1.4Zm2.8 0h-1.4v1.4h1.4v-1.4Zm2.8 0h-1.4v1.4h1.4v-1.4Zm-.7 4.2v-1.4h-1.4v1.4h1.4Z"
  }));
};

exports.SvgKeyboardMinor = SvgKeyboardMinor;
